import type { JsonObject } from '@/app-package';
import type { FeedbackDoc } from '@bb/domain/dist/schemas';
import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';

export type SaveFeedbackOptions = {
  listingId: string;
  appointmentId: string;
  feedback: JsonObject<
    Omit<
      FeedbackDoc,
      '_id' | 'id' | 'submittedAt' | 'createdAt' | 'updatedAt'
    > & { id?: string; coopSubmitted?: boolean }
  >;
};

const saveFeedback = async ({
  listingId,
  appointmentId,
  feedback,
}: SaveFeedbackOptions) => {
  const config: AxiosRequestConfig = {
    url: `/listing/${listingId}/appointment/${appointmentId}/feedback`,
    method: 'post',
    data: { ...feedback, listing: listingId, appointment: appointmentId },
  };

  await axios.request<void>(config);
};

export default saveFeedback;
